/**
 * Generated by orval v8.23.0 🍺
 * Do not edit manually.
 * Arbi API
 * OpenAPI spec version: 1.0.0
 */

export type AtsConnectionResponseSyncDirection = typeof AtsConnectionResponseSyncDirection[keyof typeof AtsConnectionResponseSyncDirection];


export const AtsConnectionResponseSyncDirection = {
  bidirectional: 'bidirectional',
  pull_only: 'pull_only',
  push_only: 'push_only',
  unknown: 'unknown',
} as const;
